import { render } from "./Abt1d.vue?vue&type=template&id=6a0ff70e"
import script from "./Abt1d.vue?vue&type=script&lang=js"
export * from "./Abt1d.vue?vue&type=script&lang=js"

import "./Abt1d.vue?vue&type=style&index=0&id=6a0ff70e&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__